import tuner from './tuner';
import nowPlayingPoller from './nowPlayingPoller';
import idle from './states/idle';
import loading from './states/loading';
import loaded from './states/loaded';
import connecting from './states/connecting';
import playing from './states/playing';
import paused from './states/paused';
import stopped from './states/stopped';
import waiting from './states/waiting';
import failed from './states/failed';

tuner.states = {
  idle: idle,
  loading: loading,
  loaded: loaded,
  connecting: connecting,
  playing: playing,
  paused: paused,
  stopped: stopped,
  waiting: waiting,
  failed: failed,
};

tuner.state = tuner.states.idle;
tuner.fetchCurrentNowPlaying = (guideId) =>
  nowPlayingPoller.fetchCurrentNowPlaying(guideId);

export default tuner;
